import React, { Component } from 'react';

class BendTimePopup extends Component {
    createHourSelectItems() {
        let items = [];
        for (let i = 1; i <= 12; i++) {
            items.push(<option key={i} value={i}>{i}</option>);
        }
        return items;
    }

    render() {
        return (
            <div>
                <div className="popup-option" style={this.props.showBedTimeInput ? {} : { display: 'none' }}>
                    <div className="popup-container">
                        <div>
                            <div className="col">
                                <label>Bed Time</label>
                            </div>
                            <div className="col">
                                <select key={`selectStartHour-${this.props.startBedTimeHour}`} defaultValue={this.props.startBedTimeHour} onChange={this.props.bedTimeHourStartChanged} >
                                    {this.createHourSelectItems()}
                                </select>
                                <select key={`selectStartMinute-${this.props.startBedTimeMinute}`} defaultValue={this.props.startBedTimeMinute} onChange={this.props.bedTimeMinuteStartChanged} >
                                    <option value="0">00</option>
                                    <option value="25">15</option>
                                    <option value="50">30</option>
                                    <option value="75">45</option>
                                </select>
                                <select key={`selectStartAmPm-${this.props.startBedTimeAmPm}`} defaultValue={this.props.startBedTimeAmPm} onChange={this.props.bedTimeAmPmStartChanged} >
                                    <option value="0">AM</option>
                                    <option value="1">PM</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div className="col">
                                <label>Wake Time</label>
                            </div>
                            <div className="col">
                                <select key={`selectEndHour-${this.props.endBedTimeHour}`} defaultValue={this.props.endBedTimeHour} onChange={this.props.bedTimeHourEndChanged} >
                                    {this.createHourSelectItems()}
                                </select>
                                <select key={`selectEndMinute-${this.props.endBedTimeMinute}`} defaultValue={this.props.endBedTimeMinute} onChange={this.props.bedTimeMinuteEndChanged} >
                                    <option value="0">00</option>
                                    <option value="25">15</option>
                                    <option value="50">30</option>
                                    <option value="75">45</option>
                                </select>
                                <select key={`selectEndAmPm-${this.props.endBedTimeAmPm}`} defaultValue={this.props.endBedTimeAmPm} onChange={this.props.bedTimeAmPmEndChanged} >
                                    <option value="0">AM</option>
                                    <option value="1">PM</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div className="col">
                                <button onClick={this.props.clearBedTime}>Clear</button>
                            </div>
                            <div className="col">
                                <button onClick={this.props.showBedTime}>Set</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default BendTimePopup;